<template>
  <section class="comparison-group">
    <h3>{{ group.title }}</h3>
    <p class="scroll-hint">
      Scroll sideways for all values and percentage changes.
    </p>
    <div
      class="table-scroll"
      role="region"
      :aria-label="group.title + ' comparison'"
      tabindex="0"
    >
      <table>
        <caption class="sr-only">
          {{
            group.title
          }}: period A, period B and change from B to A
        </caption>
        <thead>
          <tr>
            <th scope="col">Metric</th>
            <th scope="col">A</th>
            <th scope="col">B</th>
            <th scope="col">Change</th>
            <th scope="col">Change %</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in group.rows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ formatValue(row.a, row.aCurrency || row.currency) }}</td>
            <td>{{ formatValue(row.b, row.bCurrency || row.currency) }}</td>
            <td>
              {{
                row.delta === null
                  ? "—"
                  : (row.delta > 0 ? "+" : "") +
                    formatValue(row.delta, row.currency)
              }}
            </td>
            <td>
              {{
                row.percent === null
                  ? row.reason
                  : (row.percent > 0 ? "+" : "") + row.percent.toFixed(1) + "%"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
import { formatValue } from "../../services/salesComparison.cjs";
export default {
  name: "SalesComparisonTable",
  props: { group: { type: Object, required: true } },
  methods: { formatValue },
};
</script>
<style scoped>
.scroll-hint {
  display: none;
}
.comparison-group {
  margin-top: 22px;
  min-width: 0;
}
h3 {
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 10px;
}
.table-scroll {
  overflow-x: auto;
  border: 1px solid #dce4ed;
  border-radius: 10px;
}
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background: white;
}
th,
td {
  padding: 12px 16px;
  text-align: right;
  border-bottom: 1px solid #e5ebf2;
  font-variant-numeric: tabular-nums;
}
thead {
  background: #f3f6fa;
  color: #485d75;
}
th:first-child {
  text-align: left;
  min-width: 145px;
}
tbody th {
  font-weight: 550;
}
td {
  white-space: nowrap;
}
tr:last-child th,
tr:last-child td {
  border-bottom: 0;
}
.table-scroll:focus-visible {
  outline: 2px solid #1768aa;
  outline-offset: 3px;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}
@media (max-width: 600px) {
  .scroll-hint {
    display: block;
    margin: 0 0 8px;
    font-size: 12px;
    color: #53657a;
  }
  th,
  td {
    padding: 12px 10px;
  }
}
</style>
